"use client"

import { QuoteUpIcon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import { motion } from "framer-motion"

export default function QuoteSectionMinimal() {
    return (
        <section className="container mx-auto px-4 py-24">
            {/* Section Header */}
            <div className="mb-16 flex items-center justify-between border-border/70 border-b pb-6 dark:border-border/40">
                <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                    Design Ethos
                </span>
                <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                    04 · Manifesto
                </span>
            </div>

            <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                {/* Large Quote Icon - Decorative */}
                <div className="relative hidden lg:col-span-2 lg:block">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="sticky top-32"
                    >
                        <HugeiconsIcon
                            icon={QuoteUpIcon}
                            className="size-32 -rotate-12 text-muted-foreground/10"
                            size={128}
                        />
                    </motion.div>
                </div>

                {/* Content */}
                <div className="flex flex-col gap-16 lg:col-span-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="font-medium text-5xl leading-[0.95] tracking-tighter sm:text-7xl md:text-8xl lg:text-9xl">
                            The{" "}
                            <span className="relative inline-block text-muted-foreground transition-colors duration-300 hover:text-foreground">
                                small things
                                <span className="absolute -bottom-2 left-0 h-1 w-0 bg-foreground transition-all duration-300 group-hover:w-full" />
                            </span>{" "}
                            <br />
                            that shape <br />
                            experience.
                        </h2>
                    </motion.div>

                    <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                            className="space-y-6 font-light text-muted-foreground text-xl leading-relaxed"
                        >
                            <p>
                                I&apos;m a{" "}
                                <span className="font-normal text-foreground">
                                    design-minded engineer
                                </span>
                                . I notice the details that decide whether an
                                interface feels right to use.
                            </p>
                            <p>
                                Good design comes from taste plus a habit of
                                noticing the small things most people overlook.
                            </p>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            viewport={{ once: true }}
                            className="space-y-6 font-light text-muted-foreground text-xl leading-relaxed"
                        >
                            <p>
                                I care about{" "}
                                <span className="font-normal text-foreground">
                                    UX flow
                                </span>
                                ,{" "}
                                <span className="font-normal text-foreground">
                                    accessibility
                                </span>
                                , and the{" "}
                                <span className="font-normal text-foreground">
                                    micro-interactions
                                </span>{" "}
                                that decide how a product feels to use.
                            </p>
                            <p>
                                A dropdown&apos;s behavior, the timing of an
                                animation. Small choices, but they&apos;re what
                                make a product{" "}
                                <span className="font-normal text-foreground">
                                    worth using
                                </span>
                                .
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    )
}
